import { useGetProperLeverageMargin } from '@ui/features/Trade/hooks/useGetProperLeverageMargin';
import { Order } from '@ui/hooks/trade/useTradeOrders/types';
import { useTradePairInfosByPairBase } from '@ui/hooks/trade/useTradePairInfos';

import { useLeverage } from './useLeverage';

export const useLiqLostP = ({ order }: { order: Order }) => {
  const tradePairInfos = useTradePairInfosByPairBase(order.pair.address);
  const leverage = useLeverage({ order });

  const properLeverageMargin = useGetProperLeverageMargin(
    tradePairInfos,
    leverage?.toNumber(),
  );

  return properLeverageMargin?.liqLostP;
};
